// create const for configs
const ENTERPRISE_DOC_ID = "tgvairwabo";
const ENTERPRISE_NAME = "TGV'AIRWABO";
const LANDING_PAGE_URL = "https://tgvairwabo.com"

// exports all const
module.exports = {
  ENTERPRISE_DOC_ID,
  ENTERPRISE_NAME,
  LANDING_PAGE_URL
}
